import { type CategoryType } from "~/pages/ricerca";
import { type ElasticSearchBucket } from "~/utils/elasticSearchUtils";

export const filterSubCategories = (
  sources: CategoryType[],
  subCategores: CategoryType[]
) =>
  subCategores.reduce((acc, subCategory) => {
    if (sources.find((source) => source.id == subCategory.parentId))
      acc.push(subCategory);
    return acc;
  }, [] as CategoryType[]);

export const filterUnecessaryParents = (
  sources: CategoryType[],
  subSources: CategoryType[]
) =>
  sources.filter((source) => {
    const parent = subSources.find(
      (subSource) => subSource.parentId == source.id
    );
    return !parent;
  });

export const haveParentCategory = (
  subSources: CategoryType[],
  parentId: string
): boolean => !!subSources.find((subSource) => subSource.parentId === parentId);

export const addCategoriesDocCount = (
  categories: CategoryType[],
  aggregationsCategories: ElasticSearchBucket,
  aggregationsMultimedia: ElasticSearchBucket,
  aggregationsSpeciali: ElasticSearchBucket
) => {
  const aggregations = aggregationsCategories
    ?.concat(aggregationsMultimedia)
    ?.concat(aggregationsSpeciali);
  if (!aggregations || aggregations?.length == 0) return categories;
  const result = aggregations?.reduce((acc, { key, doc_count }) => {
    const findCategory = categories.find((category) => category.value == key);
    if (!findCategory || doc_count == 0) return acc;
    acc.push({
      ...findCategory,
      totArticles: doc_count,
      label: `${findCategory.label} ( ${doc_count} )`,
    });
    return acc;
  }, [] as CategoryType[]);
  return result.sort((a, b) => b.totArticles - a.totArticles);
};
